import { IVaultServiceWithAccount } from 'store/services/servicesReducer';
import { IServiceWithAccountRequest } from 'interfaces/IUser';
import { IGetAllResponse } from 'interfaces/IPaginationModel';
import { VAULT_API_URL } from 'constants/serviceUrls';
import apiInstance from './instances/apiInstances';

export const getServicesApi = async (data: IServiceWithAccountRequest)
  : Promise<IGetAllResponse<IVaultServiceWithAccount>> => {
  const res = await apiInstance.get(
    `${VAULT_API_URL}/superUser/service/with-accounts`,
    { baseURL: '', params: { ...data } },
  );
  return res.data;
};
